<template>
  <div
    class="message-text__wrap"
    :class="{
      'show--quoted': isQuotedContentPresent,
      'found-conversation': isClicked,
      'found-conversation_one': isFound,
      'hide--quoted': !isQuotedContentPresent,
    }"
  >
    <div
      v-if="!isEmail"
      v-dompurify-html="message"
      class="text-content text-content-inline"
    />
    <letter v-else class="text-content" :html="message" />
    <button
      v-if="showQuoteToggle"
      class="quoted-text--button"
      @click="toggleQuotedContent"
    >
      <span v-if="showQuotedContent">
        <fluent-icon icon="chevron-up" class="fluent-icon" size="16" />
        {{ $t('CHAT_LIST.HIDE_QUOTED_TEXT') }}
      </span>
      <span v-else>
        <fluent-icon icon="chevron-down" class="fluent-icon" size="16" />
        {{ $t('CHAT_LIST.SHOW_QUOTED_TEXT') }}
      </span>
    </button>
  </div>
</template>

<script>
import Letter from 'vue-letter';
import { BUS_EVENTS } from '../../../../../shared/constants/busEvents';

export default {
  components: { Letter },
  props: {
    message: {
      type: String,
      default: '',
    },
    isEmail: {
      type: Boolean,
      default: true,
    },
    messageId: {
      type: [Number, String],
      default: 0,
    },
    displayQuotedButton: {
      type: Boolean,
      default: false,
    },
    messageObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showQuotedContent: false,
      isClicked: false,
      isFound: true,
    };
  },
  computed: {
    isQuotedContentPresent() {
      if (!this.isEmail) {
        return this.message.includes('<blockquote');
      }
      return this.showQuotedContent;
    },
    showQuoteToggle() {
      if (!this.isEmail) {
        return false;
      }
      return this.displayQuotedButton;
    },
  },
  mounted() {
    this.attachInlineImageClickHandlers();
    bus.$on(BUS_EVENTS.SCROLL_TO_MESSAGE, data => {
      if (data && data?.messageId) {
        if (this.messageId === data.messageId) {
          this.isClicked = true;
          this.isFound = false;
          setTimeout(() => {
            this.isClicked = false;
            this.isFound = true;
          }, 1000);
        }
      }
    });
  },
  methods: {
    callInlineImagePreview(src) {
      const file = {
        sender_id: this.messageObj.sender?.id || null,
        sender_name: this.messageObj.sender?.name || null,
        sender_avatar_url: this.messageObj.sender?.thumbnail || null,
        sender_flag: this.messageObj.sender?.custom_attributes?.country || null,
        initial: true,
        conversation_id: this.messageObj.conversation_id,
        inbox_id: this.messageObj.inbox_id,
        data_url: src,
        file_type: 'image',
      };

      this.$store.commit('mediaGallery/setRecords', [file]);
      this.$store.commit('mediaGallery/setActiveRecordIndex', 0);
      return this.$nextTick(() => {
        this.$store.commit('mediaGallery/setGalleryVisibility', true);
      });
    },
    attachInlineImageClickHandlers() {
      const container = this.$el.querySelector('.text-content-inline');
      if (!container) return;
      const images = container.querySelectorAll('img');
      images.forEach(img => {
        img.style.cursor = 'pointer';
        img.onclick = () => {
          if (img.src) this.callInlineImagePreview(img.src);
        };
      });
    },
    toggleQuotedContent() {
      this.showQuotedContent = !this.showQuotedContent;
    },
  },
};
</script>
<style lang="scss">
.text-content {
  overflow: auto;

  ul,
  ol {
    padding-left: var(--space-two);
  }
  table {
    margin: 0;
    border: 0;

    td {
      margin: 0;
      border: 0;
    }

    tr {
      border-bottom: 0 !important;
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: var(--font-size-normal);
  }
}

.show--quoted {
  blockquote {
    display: block;
  }
}

.hide--quoted {
  blockquote {
    display: none;
  }
}

.quoted-text--button {
  color: var(--s-400);
  cursor: pointer;
  font-size: var(--font-size-mini);
  padding-bottom: var(--space-small);
  padding-top: var(--space-small);

  .fluent-icon {
    margin-bottom: var(--space-minus-smaller);
  }
}
</style>
